import React, { useState } from 'react';

export default function ComparisonComponent({ filePaths, onComparisonStart, onComparisonResult }) {
  const [comparisonCount, setComparisonCount] = useState(0);

  const handleCompareClick = () => {
    onComparisonStart(); // Trigger preloader

    // Give React a moment to render the spinner before blocking
    setTimeout(async () => {
      const res = await fetch('https://detrace-ecdnbwfkawftghga.centralindia-01.azurewebsites.net/compare-files', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fileNames: filePaths })
      });

      if (!res.ok) {
        console.error('compare failed', await res.text());
        return;
      }

      const output = await res.text();
      const newCount = comparisonCount + 1;
      setComparisonCount(newCount);
      const label = `Comparison ${newCount}`;

      onComparisonResult(output, newCount, label);
    }, 0);
  };

  return (
    <button onClick={handleCompareClick} className="button">
      Compare Files
    </button>
  );
}
